import { useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileBottomNav } from "@/components/MobileBottomNav";
import { EmailConfirmationBanner } from "@/components/EmailConfirmationBanner";

interface LayoutProps {
  children: React.ReactNode;
  showFooter?: boolean;
}

// Sub-rotas conhecidas do Portal do Atleta (renderizadas dentro do AthleteLayout)
const ATHLETE_PORTAL_SUBPATHS = new Set([
  "", "reservas", "aulas", "jogos", "inscricoes", "notificacoes",
  "ranking", "historico", "perfil", "times",
]);

// Routes that have their own dedicated layout (sidebar, nav, etc.)
const DEDICATED_LAYOUT_PREFIXES = ["/arena/"];

export const Layout = ({ children, showFooter = true }: LayoutProps) => {
  const location = useLocation();

  // /atleta e suas sub-rotas internas usam AthleteLayout.
  // Já /atleta/:athleteId (perfil público) deve usar o layout global com Header/Footer.
  const isAthletePortal = (() => {
    if (!location.pathname.startsWith("/atleta")) return false;
    if (location.pathname === "/atleta") return true;
    const rest = location.pathname.slice("/atleta/".length).split("/")[0];
    return ATHLETE_PORTAL_SUBPATHS.has(rest);
  })();

  const hasDedicatedLayout = isAthletePortal || DEDICATED_LAYOUT_PREFIXES.some(
    (prefix) => location.pathname === prefix || location.pathname.startsWith(prefix + (prefix.endsWith("/") ? "" : "/"))
  );

  // For routes with their own layout, render children only (no global header/footer/nav)
  if (hasDedicatedLayout) {
    return (
      <div className="min-h-screen flex flex-col safe-area-top">
        <main className="flex-1">
          {children}
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col safe-area-top">
      <EmailConfirmationBanner />
      <Header />
      <main className="flex-1 pb-20 lg:pb-0">
        {children}
      </main>
      {showFooter && <Footer />}
      <MobileBottomNav />
    </div>
  );
};